module.exports = __webpack_public_path__ + "static/media/refinitiv.62714cea.png";